import * as types from './supervisorAllocation.types'

export const actions = {
  toggleLoading: payload => ({
    type: types.TOGGLE_LOADING,
    payload,
  }),
  toggleSuccess: payload => ({
    type: types.TOGGLE_SUCCESS,
    payload,
  }),
  set: payload => ({
    type: types.SET_SUPERVISOR_ALLOCATION,
    payload,
  }),
  create: payload => ({
    type: types.CREATE_SUPERVISOR_ALLOCATION,
    payload,
  }),
  get: payload => ({
    type: types.GET_SUPERVISOR_ALLOCATION,
    payload,
  }),
  edit: payload => ({
    type: types.EDIT_SUPERVISOR_ALLOCATION,
    payload,
  }),
  delete: payload => ({
    type: types.DELETE_SUPERVISOR_ALLOCATION,
    payload,
  }),
  getOptions: () => ({
    type: types.GET_OPTIONS,
  }),
  setOptions: payload => ({
    type: types.SET_OPTIONS,
    payload,
  }),
  clearData: () => ({
    type: types.CLEAR_DATA,
  }),
  setPermissions: payload => ({
    type: types.SET_PERMISSIONS,
    payload,
  }),
  setCanBeCreated: payload => ({
    type: types.SET_CAN_BE_CREATED,
    payload,
  }),
  setErrors: payload => ({
    type: types.SET_ERRORS,
    payload,
  }),
}
